import type * as React from 'react';
import { put } from '@Domain/Api';
import type { StaffMemberPayload } from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';
import staffMemberUpdated, {
	type StaffMemberUpdatedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberUpdated';
import staffMemberUpdateFailed, {
	type StaffMemberUpdateFailedAction,
} from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMemberUpdateFailed';
import type UpdateStaffMember from '@Application/Facilities/StaffMembers/StaffMembers/Commands/UpdateStaffMember';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = StaffMemberUpdatedAction | StaffMemberUpdateFailedAction;

export default (command: UpdateStaffMember) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<StaffMemberPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/staff-members/${command.staffMemberId}`,
				command.toJSON(),
			);

			const action = staffMemberUpdated(payload, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = staffMemberUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
